import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FiCheck, FiGlobe } from 'react-icons/fi';
import { SUPPORTED_LANGUAGES } from '@web/i18n';

export function LanguageMenu({ onChange }: { onChange?: (code: string) => void }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? 'en';
  return (
    <Menu position="bottom-end" width={180}>
      <Menu.Target>
        <Tooltip label={t('common.language')}>
          <ActionIcon size="lg" aria-label={t('common.language')}>
            <FiGlobe size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <Menu.Item
            key={lang.code}
            lang={lang.code}
            rightSection={current === lang.code ? <FiCheck size={14} /> : null}
            onClick={() => {
              void i18n.changeLanguage(lang.code);
              onChange?.(lang.code);
            }}
          >
            {lang.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
